import React from 'react';
import PuzzlePanel from '../../layout/panel/PuzzlePanel';
import { Component } from '../../../dispatcher/modules';
import { Container, HBox, VBox } from '../../index';
import PuzzleDateRange from '../../UI/fields/date/PuzzleDateRange';
import { config } from './FilterDialog.config';
import withFormControl from '../../hoc/form/withFormControl';
import FieldWrap from '../../layout/field_wrap/FieldWrap';
import PuzzleComboBox from '../../UI/fields/combo/PuzzleComboBox';
import PuzzleInput from '../../UI/fields/input/PuzzleInput';
import PuzzleMultiselect from '../../UI/fields/multiselect/PuzzleMultiselect';
import {
  FILTER_DIALOG_MAP_INPUT_PROPS,
  FILTER_DIALOG_PROPS,
  FILTER_DIALOG_STATE
} from './Types';
import { SEARCH_FILTER_FIELDS } from './Types';
import SavedFilter from './SavedFilter';
import _, { cloneDeep, isArray } from 'lodash';
import PuzzleColorPicker from '../../UI/fields/color_picker/PuzzleColorPicker';
import PuzzleTextArea from '../../UI/fields/textarea/PuzzleTextArea';
import { Position } from '../../../dispatcher/Types';
import PuzzleRemoteMultiselectAllData from '../../UI/fields/multiselect/PuzzleRemoteMultiselectAllData';
import PuzzleRemoteComboAllData from '../../UI/fields/combo/PuzzleRemoteComboAllData';
import { 
  SelectionRange 
} from '@progress/kendo-react-dateinputs/dist/npm/calendar/models/SelectionRange';

class FilterDialog extends Component<FILTER_DIALOG_PROPS, FILTER_DIALOG_STATE> {
  private mappingValueFilterFields = {};
  originalConfig: any = cloneDeep(config);

  constructor(props:FILTER_DIALOG_PROPS) {
    super(props);
    this.state = {
      ...this.state,
      ...props
    };
  }

  /**
   * Returns true if value is range date type
   * @param {any} value
   */
  private isRangeDateType = (value: SelectionRange) => _.isObject(value) && !_.isUndefined(value?.start) && !_.isUndefined(value?.end)

  /**
   * Returns true if there is filter with name that is same as filterName field value
   */
  public isFilterNameExisted = () => {
    const { getData } = this.props.form;
    const { filterName } = getData('filterName');
    const { savedFilters } = this.state;
    const filterWithSameFilterName = savedFilters.find(filter => filter.filterName === filterName);
    return !_.isEmpty(filterWithSameFilterName);
  }

  /**
   * Returns filter params, so that it is in format for sending to server side
   * @param filterParams
   */
  private getConvertedFilterParams = (filterParams: any[]) => {
    const dateRanges = {};
    const filterParamsConverted = [];
    let enablePush;
    filterParams.forEach((field) => {
      enablePush = true;
      Object.keys(this.mappingValueFilterFields).forEach((key) => {
        const item = this.mappingValueFilterFields[key];
        if (item.type === 'daterange' && (field.name === item.value.start || field.name === item.value.end)) {
          enablePush = false;
          if (_.isUndefined(dateRanges[key])) {
            dateRanges[key] = {
              start: field.name === item.value.start ? field.value : null,
              end: field.name === item.value.end ? field.value : null
            };
          } else {
            dateRanges[key] = {
              start: field.name === item.value.start ? field.value : dateRanges[key].start,
              end: field.name === item.value.end ? field.value : dateRanges[key].end
            };
          }
        }
      });
      if (enablePush) {
        filterParamsConverted.push(field);
      }
    });
    if (!_.isEmpty(dateRanges)) {
      Object.keys(dateRanges).forEach((key) => {
        filterParamsConverted.push({
          name: key,
          value: dateRanges[key]
        });
      });
    }
    return filterParamsConverted;
  }

  /**
   * Loads saved filter data
   * @param {string} filterName
   * @param {string} filterColor
   * @param {any[]} filterParams
   * @param {Function} afterChangeHandler
   */
  loadSavedFilter = (filterName, filterColor, filterParams, afterChangeHandler?: Function) => {
    if (!_.isFunction(afterChangeHandler)) {
      afterChangeHandler = this.afterChangeHandler;
    }
    const convertedFilterParams = this.getConvertedFilterParams(filterParams);
    const { setData, getData, clearAll } = this.props.form;
    clearAll(() => {
      let data = getData();
      if (_.isArray(convertedFilterParams)) {
        convertedFilterParams.forEach((field) => {
          data[field.name] = field.value;
        });
      }
      data = { ...data, filterName, filterColor };
      setData(data, null, afterChangeHandler);
    });
  }

  /**
   * Loads saved filter data and saves new filter
   * @param {string} filterName
   * @param {string} filterColor
   * @param {any[]} filterParams
   */
  public loadSavedFilterAndSaveNewOne = (filterName, filterColor, filterParams) => {
    this.loadSavedFilter(filterName, filterColor, filterParams, this.saveNewFilter);
  }

  /**
   * Loads saved filter data and searches
   * @param {string} filterName
   * @param {string} filterColor
   * @param {any[]} filterParams
   */
  public loadSavedFilterAndSearch = (filterName, filterColor, filterParams) => {
    this.loadSavedFilter(filterName, filterColor, filterParams, this.searchFilter);
  }

  /**
   * Maps filter fields to input fields
   * @param {any[]} filterFields
   */
  mapFilterFields = (filterFields: any[] = []) => {
    let fields = [];
    let childrenWidth: any[];
    let remainChildrenWidth: any[];
    let sumPercent;
    let percentCounter;
    let remainingPercentPerChild;
    let remainingPercentCounter;
    let remainingPercent;
    let childrenRowFields: any[];
    let remainRowFields: any[];
    if (_.isArray(filterFields)) {
      filterFields.forEach((rowFields: any[], rowIndex) => {
        sumPercent = 0;
        percentCounter = 0;
        childrenWidth = [];
        remainChildrenWidth = [];
        childrenRowFields = [];
        remainRowFields = [];
        rowFields.forEach((field, index) => {
          if (field.flexWidth) {
            childrenRowFields.push(field);
            sumPercent += Math.round(field.flexWidth * 12 / 100);
            percentCounter++;
            if (percentCounter !== index + 1) {
              throw 'Parameter "flexWidth" can be in item with index from 0 to n < length - 1 !';
            }
          } else {
            remainRowFields.push(field);
          }
        });
        remainingPercentCounter = rowFields.length - percentCounter;
        remainingPercent = 12 - sumPercent;
        remainingPercentPerChild = remainingPercent / remainingPercentCounter;
        rowFields.forEach((field) => {
          if (field.flexWidth) {
            childrenWidth.push(Math.round((field.flexWidth * 12 * 12) / (100 * sumPercent)));
          } else {
            remainChildrenWidth.push((remainingPercentPerChild * 12) / remainingPercent);
          }
        });
        if (remainingPercent > 0 && remainingPercent < 12) {
          fields.push(
            <FieldWrap
              withValidation
              key={`filterrowwrap-key-${rowIndex}`}
              layout={[sumPercent, remainingPercent]}
            >
              {
                childrenWidth.length > 1 ? <FieldWrap
                  withValidation
                  key={`filterrowwrap-key-part-1-${rowIndex}`}
                  layout={childrenWidth}
                >
                  {
                    childrenRowFields.map((field, index) => this.mapInput(field, rowIndex, index))
                  }
                </FieldWrap> : childrenRowFields.map((field, index) => this.mapInput(field, rowIndex, index))
              }
              {
                remainChildrenWidth.length > 1 ?
                  <FieldWrap
                    withValidation
                    key={`filterrowwrap-key-part-2-${rowIndex}`}
                    layout={remainChildrenWidth}
                  >
                    {
                      remainRowFields.map((field, index) => this.mapInput(field, rowIndex, index))
                    }
                  </FieldWrap> : remainRowFields.map((field, index) => this.mapInput(field, rowIndex, index))
              }
            </FieldWrap>
          );
        } else {
          fields.push(
            <FieldWrap
              withValidation
              key={`filterrowwrap-key-${rowIndex}`}
              layout={remainChildrenWidth}
            >
              {
                rowFields.map((field, index) => this.mapInput(field, rowIndex, index))
              }
            </FieldWrap>
          );
        }
      });
    }

    return fields.map(field => field);
  };

  /**
   * Map input field by type
   * @param {any} field
   * @param {number} rowIndex
   * @param {number} index
   */
  mapInput = (field, rowIndex, index) => {
    const { getFields, handleBlur, handleChange } = this.props.form;
    const fields = getFields();
    let formField = fields[field.name];

    if (!formField) {
      return null;
    }

    let props: FILTER_DIALOG_MAP_INPUT_PROPS = {
      asField: true,
      fieldMandatory: field.required,
      key: `filterfield-key-${rowIndex}-${index}`,
      size: 'medium',
      label: field.label,
      name: field.name,
      dataCy: `filterInput-${field.name}`,
      onBlur: handleBlur,
      onChange: handleChange,
      withValidation: true,
      ...formField,
      errorTxt: fields[field.name] && this.translateErrorMessage(fields[field.name])
    };

    const additionalProps = {
      data: field.data,
      textField: field.textField,
      dataItemKey: field.dataItemKey,
      remoteVirtualScrolling: field.remoteVirtualScrolling
    };

    let cmp;
    let { value } = props;

    switch (field.type) {
      case 'input':
        if (_.isUndefined(value)) {
          value = '';
        }
        cmp = (
          <PuzzleInput
            {...props}
            value={value}
          />);
        break;
      case 'textarea':
        if (_.isUndefined(value)) {
          value = '';
        }
        cmp = (
          <PuzzleTextArea
            {...props}
            value={value}
          />);
        break;
      case 'multiselect':
        if (_.isUndefined(value)) {
          value = null;
        }
        const MultiselectComponent = field.remoteVirtualScrolling ? PuzzleRemoteMultiselectAllData : PuzzleMultiselect;
        let autoClose = _.isUndefined(field.autoClose) ? false : field.autoClose;

        cmp = (
          <MultiselectComponent
            autoClose={autoClose}
            {...props}
            {...additionalProps}
            value={value}
          />);
        break;
      case 'daterange':
        if (_.isUndefined(value)) {
          value = {
            start: null,
            end: null
          };
        }
        let { start, end } = value;
        start = _.isDate(start) || _.isNull(start) ? start : new Date(start);
        end = _.isDate(end) || _.isNull(end) ? end : new Date(end);
        value = {
          start,
          end
        };
        cmp = (
          <PuzzleDateRange
            startDateInputSettings={{
              label: this.translate('dateRange.from'),
              format: field.format || 'dd/M/yy'
            }}
            endDateInputSettings={{
              label: this.translate('dateRange.to'),
              format: field.format || 'dd/M/yy'
            }}
            valid={true}
            datePickerLabel={field.label}
            {...props}
            value={value}
          />);
        break;
      case 'combobox':
        if (_.isEmpty(value)) {
          value = null;
        }
        const ComboBoxComponent = field.remoteVirtualScrolling ? PuzzleRemoteComboAllData : PuzzleComboBox;
        cmp = (
          <ComboBoxComponent
            {...props}
            {...additionalProps}
            value={value}
          />);
        break;
      case 'empty':
        cmp = <div />;
        break;
    }
    return (
      <React.Fragment
        key={`filterfieldwrap-key-${rowIndex}-${index}`}
      >
        {cmp}
      </React.Fragment>
    );
  };

  /**
   * Maps saved filter components
   * @param {any} filter
   */
  mapSavedFilters = (filter) => {
    const filterColor = _.isArray(filter.filterParams) && filter.filterParams.find(field => field.name === 'filterColor');
    return (
      <SavedFilter
        {...filter}
        filterColor={filterColor && filterColor.value}
        key={`savedfilter-key-${filter.filterName}`}
        endPoints={this.props.endPoints}
      />
    );
  }

  /**
   * @inheritDoc
   */
  moduleDidMount() {
    let fields = {};
    let fieldName;
    const { filterFields, gridColumnFilterData } = this.props;
    if (_.isArray(filterFields)) {
      filterFields.forEach((rowFields: SEARCH_FILTER_FIELDS) => {
        rowFields.forEach((field) => {
          fieldName = field.name;
          const gridColumnFilterDataValue = _.get(gridColumnFilterData, fieldName, undefined);
          const value = _.isUndefined(gridColumnFilterDataValue) ? field.value : gridColumnFilterDataValue;
          fields[fieldName] = { ...field, value };
          if (!_.isUndefined(field.mappingValue)) {
            this.mappingValueFilterFields[fieldName] = {
              value: field.mappingValue,
              type: field.type
            };
            if (_.isString(value) && !_.isUndefined(field.mappingValue.delimiter)) {
              fields[fieldName].value = value.split(field.mappingValue.delimiter);
            } else if (value && field.mappingValue.dataItemKey && isArray(fields[fieldName]?.data)) {
              fields[fieldName].value = fields[fieldName]?.data?.filter(comboData => comboData[field.mappingValue.dataItemKey].toString() === value.toString());
              fields[fieldName].value = fields[fieldName].value.length ? fields[fieldName].value[0] : null;
            }
          }
        });
      });
    }
    this.props.form.setFields(fields);
  }

  /**
   * Clears all fields
   */
  clearAll = () => {
    const { clearAll } = this.props.form;
    this.dispatch('UpdateFilters', Position.start, {
      isSaveFilterDisabled: true
    });
    clearAll(null, this.originalConfig);
  }

  /**
   * Returns all data
   */
  getData = () => this.props.form.getData();

  /**
   * Return filter params for filter manipulation (Save, Clone)
   */
  getFilterParams = () => {
    const data = this.getData();
    const filterParams = [];
    Object.keys(data).forEach((field) => {
      const mappingValueFilterFieldsItem = this.mappingValueFilterFields[field];
      if (_.isUndefined(mappingValueFilterFieldsItem)) {
        filterParams.push({
          name: field,
          value: data[field]
        });
      } else {
        if (mappingValueFilterFieldsItem.type === 'daterange' && !_.isUndefined(data[field])) {
          const { start, end } = mappingValueFilterFieldsItem.value;
          filterParams.push({
            name: start,
            value: data[field].start
          });
          filterParams.push({
            name: end,
            value: data[field].end
          });
        } else if (['multiselect', 'combobox'].includes(mappingValueFilterFieldsItem.type) && !_.isUndefined(data[field])) {
          filterParams.push({
            name: field,
            value: data[field]
          });
        }
      }
    });
    return {
      filterParams,
      filterName: data.filterName
    };
  }

  /**
   * Return filter params for filter search
   */
  getSearchFilterParams = () => {
    let data = this.getData();
    delete data.filterColor;
    delete data.filterName;
    const searchData = {};
    Object.keys(data).forEach((prop) => {
      if (data.hasOwnProperty(prop) && !_.isEmpty(data[prop]) && !(this.isRangeDateType(data[prop]) && !data[prop]?.start && !data[prop]?.end)) {
        const mappingValueFilterFieldsItem = this.mappingValueFilterFields[prop];
        if (_.isUndefined(mappingValueFilterFieldsItem)) {
          searchData[prop] = data[prop];
        } else {
          if (mappingValueFilterFieldsItem.type === 'daterange' && !_.isUndefined(data[prop])) {
            const { start, end } = mappingValueFilterFieldsItem.value;
            searchData[start] = new Date(data[prop].start).toISOString().split('.')[0];
            searchData[end] = new Date(data[prop].end).toISOString().split('.')[0];
          } else if (mappingValueFilterFieldsItem.type === 'multiselect' && !_.isUndefined(data[prop])) {
            if (mappingValueFilterFieldsItem?.value?.dataItemKey) {
              data[prop] = data[prop].map(item => item[mappingValueFilterFieldsItem.value.dataItemKey]);
            }
            searchData[prop] = data[prop].join(mappingValueFilterFieldsItem.value.delimiter);
          } else if (mappingValueFilterFieldsItem.type === 'combobox' && !_.isUndefined(data[prop])) {
            searchData[prop] = data[prop][mappingValueFilterFieldsItem.value.dataItemKey];
          }
        }
      }
    });
    return searchData;
  }

  /**
   * Returns clone filter name
   * @param {String} filterName
   * @param {Number} cloneSuffix
   */
  getCloneFilterName = (filterName: string, cloneSuffix = 1) => {
    let cloneFilterName = `${filterName} (${cloneSuffix})`;
    const { savedFilters } = this.state;
    const duplicateFilter = savedFilters.find(filter => filter.filterName === cloneFilterName);
    if (duplicateFilter) {
      cloneFilterName = this.getCloneFilterName(filterName, ++cloneSuffix);
    }
    return cloneFilterName;
  }
  /**
   * Trims leading and trailing spaces in filter name on blur
   * @param {Event} e
   */
  onFilterNameBlur = (e:any) => {
    const { handleBlur } = this.props.form;
    let value:any = e?.value || e?.target?.value;
    const name = e.target?.name || e.target?.props?.name;

    value = value.trim().replace(/ +/g, ' ');
    const event = {
      value: value,
      target: {
        value: value,
        name
      }
    };
    handleBlur(event);
  }
  /**
   * Saves state on filter name change
   * @param {Event} e
   */
  onFilterNameChange = (e) => {
    const { handleChange } = this.props.form;
    handleChange(e, this.afterChangeHandler);
  }

  /**
   * Executes after change event
   */
  afterChangeHandler = () => {
    const { isValid } = this.props.form;
    let valid = isValid();
    this.dispatch('UpdateFilters', Position.start, {
      isSaveFilterDisabled: !valid
    });
  }

  /**
   * Saves new cloned filter
   */
  public saveNewFilter = () => {
    this.dispatch('SaveFilter', Position.end);
  }

  /**
   * Searches filter
   */
  public searchFilter = () => {
    this.dispatch('SearchFilter', Position.end);
  }

  /**
   * Saves state on color change
   * @param {Event} e
   */
  onColorChange = (e) => {
    const { handleChange } = this.props.form;
    this.setState({
      filterColor: e.value
    }, () => handleChange(e));
  }

  /**
   * Update saved filters after clone or delete
   * @param {any[]} savedFilters
   */
  updateSavedFilters = savedFilters => this.setState({
    savedFilters: savedFilters
  });

  renderBody() {
    let { filterFields = {}, savedFilters = [] } = this.state;
    const { getFields, handleBlur, handleChange } = this.props.form;
    const {
      filterName,
      filterColor
    } = getFields();
    return (
      <Container
        className={'tp-filter-dialog'}
      >
        <HBox>
          <Container className={'tp-saved-filters-pane'}>
            <VBox>
              <PuzzlePanel
                titleClassName={'tp-color-accent'}
                title={this.translate('savedFilters')}
                titleLine
              >
                <div className={'saved-filters-group'}>
                  {savedFilters.length ? savedFilters.map(this.mapSavedFilters.bind(this)) : <VBox
                    paddingTop
                    gap={4}
                    alignItemsCenter
                  >
                    <span
                      className={'no-saved-searches'}
                    ></span>
                    <span>{this.translate('noSavedFilters')}</span>
                  </VBox>}
                </div>
              </PuzzlePanel>
            </VBox>
          </Container>
          <div className={'tp-vertical-line'} />
          <Container className={'tp-filter-form-pane'}>
            <VBox>
              <PuzzlePanel
                className={'tp-saved-filter-options'}
                title={this.translate('saveFilterOptions')}
                legendOnly
              >
                <FieldWrap
                  withValidation
                  layout={[8, 4]}
                >
                  <PuzzleInput
                    className={'tp-filter-name'}
                    asField
                    fieldMandatory
                    withValidation
                    onBlur={this.onFilterNameBlur}
                    onChange={this.onFilterNameChange}
                    label={this.translate('filterName')}
                    errorTxt={this.translateErrorMessage(filterName)}
                    name={'filterName'}
                    dataCy={'filterInput-filterName'}
                    {...filterName}
                  />
                  <PuzzleColorPicker
                    className={'tp-filter-color'}
                    asField
                    withValidation
                    onBlur={handleBlur}
                    onChange={handleChange}
                    name={'filterColor'}
                    look={'circle'}
                    label={this.translate('filterColor')}
                    dataCy={'filterInput-filterColor'}
                    {...filterColor}
                  />
                </FieldWrap>
              </PuzzlePanel>
              <PuzzlePanel
                titleClassName={'tp-color-accent'}
                titleLine
                title={this.translate('filterCriterias')}
              >
                {this.mapFilterFields(filterFields)}
              </PuzzlePanel>
            </VBox>
          </Container>
        </HBox>
      </Container>
    );
  }
}

export default withFormControl<FILTER_DIALOG_PROPS>(config)(FilterDialog);
export {
  FilterDialog as FilterDialogComponent
};
